import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppStickyButton() {
  const phoneNumber = "919054523166";

  const message = encodeURIComponent(
    "Hello Dr. Detoxer,\n\nI want to know more about your fruit & vegetable wash. Please share details and pricing."
  );

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-[9999] flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#25D366] hover:scale-105 active:scale-95 transition-all duration-200 whatsapp-pulse"
    >
      <FaWhatsapp size={28} color="#fff" />
    </a>
  );
}